import React from 'react';
import {
  Create,
  SaveButton,
  SimpleForm,
  Toolbar,
  useNotify,
  useRedirect,
} from 'react-admin';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import { FormUnifiedSend } from '../../components';
import { track, EVENTS } from '../../lib/analytics';
import cleanEmpty from '../../lib/cleanEmpty';
import { validateUnifiedSendAudience } from '../../lib/unifiedSend';

const toolbarSx = {
  justifyContent: 'space-between'
};

const CreateUnifiedSend: React.FC = ({ ...props }) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const CreateToolbar = (props) => {
    return (
      <Toolbar {...props} sx={toolbarSx}>
        <SaveButton />
      </Toolbar>
    );
  }

  return (
    <Permission permission={PERMISSIONS.CREATE_PRODUCT}>
      <Create
        {...props}
        title="Cadastrar novo envio único"
        transform={cleanEmpty}
        mutationOptions={{
          onSuccess: (data: any, variables: any) => {
            track(EVENTS.UNIFIED_SEND_CREATED, {
              push_notification: !!variables?.data?.pushNotification,
            });
            notify('ra.notification.created', { type: 'info', messageArgs: { smart_count: 1 } });
            redirect('list', 'chains/chainId/unified-send');
          },
        }}
      >
        <SimpleForm toolbar={<CreateToolbar />} validate={validateUnifiedSendAudience} defaultValues={{ pushNotification: true }}>
          <FormUnifiedSend />
        </SimpleForm>
      </Create>
    </Permission>
  )
}

export default CreateUnifiedSend
